import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import FlipCountdown from 'vue2-flip-countdown'
import { required } from '@validations'
import { alphanumeric } from '@/mixins/alphanumeric'
import ProfileApis from '@/services/apis/profile'
import axiosIns from '@/libs/axios'

const userProfile = new ProfileApis()
export default {
  components: {
    vSelect,
    FlipCountdown,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      form: {
        old_password: '',
        password: '',
        password_confirmation: '',
      },
      twoFactorList: [],
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      twoFactorType: '',
      pendingChangePassword: false,
      pendingTwoFactor: false,
      userProfile: {
        profile: {},
        twoFactorAuth: {
          is_active: false,
          type: '',
        },
      },
      confirmFormModal: false,
      pendingReSendOtp: false,
      pendingOTP: false,
      deadline: '',
      remained_time: 0,
      reSendBtn: false,
      required,
    }
  },
  computed: {
    isEnableSecurityPassword() {
      return process.env.VUE_APP_ENABLE_SECURITY_PASSWORD === 'true'
    },
    profileInfo() {
      return this.$store.state.profile.profileInfo
    },
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    options() {
      return this.twoFactorList.map(item => ({
        label: this.$t(item),
        key: item,
      }))
    },
  },
  watch: {
    profileInfo() {
      if (this.profileInfo && this.profileInfo.twoFactorAuth) {
        // eslint-disable-next-line eqeqeq
        if (this.profileInfo.twoFactorAuth.is_active == 1) {
          this.twoFactorType = {
            label: this.$t(`${this.profileInfo.twoFactorAuth.type}`),
            key: this.profileInfo.twoFactorAuth.type,
          }
        }
        this.userProfile = {
          ...this.profileInfo,
          twoFactorAuth: {
            ...this.profileInfo.twoFactorAuth,
            is_active: this.profileInfo?.twoFactorAuth?.is_active === 1,
          },
        }
      }
    },
    // eslint-disable-next-line func-names
    'userProfile.twoFactorAuth.is_active': function (val) {
      if (!val) {
        this.twoFactorType = {
          label: '',
          key: '',
        }
      }
    },
  },
  mounted() {
    userProfile.twoFactorList().then(res => {
      this.twoFactorList = res.data.results
    })
    if (this.profileInfo && this.profileInfo.twoFactorAuth) {
      // eslint-disable-next-line eqeqeq
      if (this.profileInfo.twoFactorAuth.is_active == 1) {
        this.twoFactorType = {
          label: this.$t(`${this.profileInfo.twoFactorAuth.type}`),
          key: this.profileInfo.twoFactorAuth.type,
        }
      }
      this.userProfile = {
        ...this.profileInfo,
        twoFactorAuth: {
          ...this.profileInfo.twoFactorAuth,
          is_active: this.profileInfo?.twoFactorAuth?.is_active === 1,
        },
      }
    }
  },
  methods: {
    async changePassword() {
      const success = await this.$refs.securityTab.validate()
      if (success) {
        this.pendingChangePassword = true
        userProfile.storeChangePassword(this.form).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
        }).finally(() => {
          this.pendingChangePassword = false
        })
      }
    },
    async saveFactor(isResend = false) {
      this.$refs.twoFactor.validate().then(async success => {
        if (success) {
          if (isResend) {
            this.pendingReSendOtp = true
          } else {
            this.pendingTwoFactor = true
          }
          const active = this.userProfile.twoFactorAuth.is_active === true ? 1 : 0
          const data = {
            is_active: (active).toString(),
            type: this.twoFactorType.key,
          }
          await userProfile.storeFactor(data).then(res => {
            this.deadline = this.getExpireTime(res.data.results.remained_time)
            this.remained_time = (res.data.results.remained_time)
            if (!isResend) {
              this.confirmFormModal = true
            }
            this.$swal({
              title: res.data.message,
              icon: 'success',
              timer: 2500,
              showConfirmButton: false,
            })
          }).catch(error => {
            if (error.data?.results?.remained_time) {
              this.confirmFormModal = true
              this.deadline = this.getExpireTime(error.data?.results?.remained_time)
              this.remained_time = (error.data?.results?.remained_time)
            }
          })
            .finally(() => {
              this.pendingTwoFactor = false
              this.pendingReSendOtp = false
            })
        }
      })
    },

    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },

    async handleOTP(verifyCode) {
      this.pendingOTP = true

      await axiosIns.post('two-f-a/verify-code', { code: verifyCode })
        .then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.confirmFormModal = false
        }).catch(error => {
          if (error.response.status === 422) {
            this.toast('Verification code is wrong', 'danger')
          }
        })
        .finally(() => {
          this.pendingOTP = false
        })
    },
    getExpireTime(expireTime) {
      const currentDate = new Date()
      const msSinceEpoch = currentDate.getTime()
      const seventeenHoursLater = new Date(msSinceEpoch + expireTime * 1000)
      const currentDayOfMonth = seventeenHoursLater.getDate()
      const currentMonth = seventeenHoursLater.getMonth()
      const currentYear = seventeenHoursLater.getFullYear()
      const hours = seventeenHoursLater.getHours()
      const minutes = seventeenHoursLater.getMinutes()
      const seconds = seventeenHoursLater.getSeconds()
      const dateString = `${currentYear}-${currentMonth + 1}-${currentDayOfMonth} ${hours}:${minutes}:${seconds}`
      return dateString
    },
    timeElapsedHandler() {
      this.reSendBtn = true
    },
  },
}
